import React from 'react';
import {Row, Col} from 'react-bootstrap';
import { toShortDateTimeDisplayFromStr } from '../../../util/ChartUtils';
import PRContent from './PRContent';

const TranscriptInteraction = (props) => {

    let interaction = props.interaction;
    let prompts = interaction.prompts;
    let responses = interaction.responses;

    return (
        <>
        <Row>
            <Col>
                <div className='interaction-date'>
                {toShortDateTimeDisplayFromStr(interaction.requestDate)}
                </div>
                
            </Col>
            <Col className='d-flex justify-content-end'>
                {/*{interaction?.model?.model != null ? <div className='interaction-meta me-2'>{interaction.model.model}</div> : <></>}*/}
                <div className='interaction-tokens'>
                {interaction.totalTokens} tokens ({interaction.promptTokens} in {interaction.completionTokens} out)
                in {interaction.latency}ms
                </div>
                
            </Col>
        </Row>
        <Row>
            <Col>
                <div className='d-flex justif-content-start interaction-meta'>
                    {interaction?.model?.model != null ? <div className='me-2'>model: {interaction.model.model}</div> : <></>} 
                    {interaction?.temperature != null ? <div className='me-2'>temperature: {interaction.temperature}</div> : <></>}
                    {interaction?.topP != null ? <div className='me-2'>top_p: {interaction.topP}</div> : <></>}
                    {interaction?.topK != null ? <div className='me-2'>top_k: {interaction.topK}</div> : <></>}
                    {interaction?.presencePenalty != null ? <div className='me-2'>presence_penalty: {interaction.presencePenalty}</div> : <></>}
                    {interaction?.frequencyPenalty != null ? <div className='me-2'>frequency_penalty: {interaction.frequencyPenalty}</div> : <></>}
                    {interaction?.logitBias != null ? <div className='me-2'>logit_bias: {interaction.logitBias}</div> : <></>}
                    {interaction?.maxTokens != null ? <div className='me-2'>max_tokens: {interaction.maxTokens}</div> : <></>}
                </div>
            </Col>
        </Row>
        <Row className='mb-3 interaction-card2'>
            <Col>
                {prompts.map((prompt, p)=> (
                    <div key={`prompt.${p}`} className='transcript-msg'>
                        <div className='transcript-role'>{prompt.role} {prompt.author}</div>
                        <div className={`chat-bubble chat-${prompt?.role}`}><PRContent text={prompt.prompt} typeId={prompt.typeId} filepath={prompt.filepath}/></div>
                    </div>
                ))}
            </Col>
            <Col>
                {responses.map((response, m)=> (
                    <div key={`response.${m}`} className='transcript-msg'>
                        <div className='transcript-role'>{response.role}</div>
                        <div className={`chat-bubble chat-${response?.role}`}><PRContent text={response.response} typeId={response.typeId} filepath={response.filepath}/></div>
                        {response.finishReason ? (<div className='transcript-finish'>{response.finishReason}</div>) : null}
                    </div>
                ))}
            </Col>
        </Row>
        </>
    )

}

export default TranscriptInteraction;